/*global $*/
/*eslint no-undef: "error"*/
export default class ButtonGallery {
	classButton = 'button-gallery--button'
	classItem = 'button-gallery--item'
	classOpen = 'gallery-list---open'

	constructor () {
		let self = this

		$(`.${self.classButton}`).click(function () {
			$(`.${self.classItem}`).addClass(self.classOpen)
		})
	}
}
